import JobCommentReactionApi from "../generated/api/JobCommentReactionApi";

class JobCommentReactionService {
  constructor() {
    this.JobCommentReactionApi = new JobCommentReactionApi();
  }

  async addReaction(commentReactionRequest, preventAlert) {
    if (preventAlert === undefined) {
      preventAlert = true;
    }
    return await window.$A.HandleApiResponse(
      this.JobCommentReactionApi.addReaction({ commentReactionRequest }),
      "Reaction Added",
      preventAlert
    );
  }

  async removeReaction(reactionId, preventAlert) {
    if (preventAlert === undefined) {
      preventAlert = true;
    }
    return await window.$A.HandleApiResponse(
      this.JobCommentReactionApi.removeReaction(reactionId),
      "Reaction Removed",
      preventAlert
    );
  }
}

export default JobCommentReactionService;
